import axios, {HttpStatusCode} from 'axios'

export const configureRefreshTokenInterceptor = (refresh: () => Promise<void>) => {
  axios.interceptors.response.use(
    res => res,
    async err => {
      const config = err?.config

      if (err?.response?.status === HttpStatusCode.Unauthorized && !config?._isRetry) {
        config._isRetry = true
        // unset the auth header for this request
        if (config?.headers) {
          config.headers.Authorization = undefined
        }
        await refresh()
        return axios(config)
      }

      throw err
    }
  )
}
